// Libraries
import * as Yup from 'yup';
// Models
import { IValidateSalary } from '@pages/employees/models/Employee';
import { IDataCompany } from '../models/DataCompany';
// Hooks
import { useValidateDocumentNumber } from '@hooks/useValidateDocumentNumber';
// Utils
import { ValidationMessage } from '@utils/Validations';
import { TypesDocumentIds } from '@pages/employees/constants/Employees';

export const useValidateDataCompany = (): {
    validationSchema: Yup.SchemaOf<IDataCompany>;
    validateNit: (values: IDataCompany) => IValidateSalary | object;
} => {
    const { validateDocumentNumber } = useValidateDocumentNumber();

    /**
     * Validate complete form
     * @param {IDataCompany} values - Values form
     * @returns {IValidateSalary | object} error from validation
     */
    const validateNit = (values: IDataCompany): IValidateSalary | object => {
        const errors: IValidateSalary = {};

        if (!values.document_type_id) {
            errors.document_type_id = ValidationMessage.required;
        } else if (!values.document_number) {
            errors.document_number = ValidationMessage.required;
        }
        const documentNumberErrors = validateDocumentNumber(values.document_number, values.document_type_id);

        return { ...errors, ...documentNumberErrors };
    };

    const validationSchema = Yup.object().shape({
        document_type_id: Yup.string().required(ValidationMessage.required),
        document_number: Yup.string().required(ValidationMessage.required),
        plan_type_id: Yup.string().required(ValidationMessage.required),
        data_processing: Yup.boolean().defined(),
        free_demo: Yup.boolean().defined(),
        dv: Yup.string().optional(),
        company_name: Yup.string().when('document_type_id', {
            is: TypesDocumentIds.NIT,
            then: Yup.string().required(ValidationMessage.required),
            otherwise: Yup.string().optional(),
        }),

        first_name: Yup.string().when('document_type_id', {
            is: TypesDocumentIds.CC,
            then: Yup.string().required(ValidationMessage.required),
            otherwise: Yup.string().optional(),
        }),
        second_name: Yup.string().when('document_type_id', {
            is: TypesDocumentIds.CC,
            then: Yup.string().optional(),
            otherwise: Yup.string().optional(),
        }),
        first_last_name: Yup.string().when('document_type_id', {
            is: TypesDocumentIds.CC,
            then: Yup.string().required(ValidationMessage.required),
            otherwise: Yup.string().optional(),
        }),
        second_last_name: Yup.string().when('document_type_id', {
            is: TypesDocumentIds.CC,
            then: Yup.string().optional(),
            otherwise: Yup.string().optional(),
        }),
    });

    return {
        validationSchema,
        validateNit,
    };
};
